import React from "react";
import OTPInput from "react-otp-input";

interface OtpInputCommonProps {
  value: string;
  onChange: (otp: string) => void;
  numInputs: number;
}

const ICOtpInput: React.FC<OtpInputCommonProps> = ({
  value,
  onChange,
  numInputs,
}) => {
  return (
    <OTPInput
      inputType="number"
      shouldAutoFocus
      value={value}
      onChange={onChange}
      numInputs={numInputs}
      containerStyle="remove-number-spinner"
      renderInput={(props) => <input {...props} />}
      inputStyle={{
        marginRight: "20px",
        border: "1px solid grey",
        outline: "none",
        height: "42px",
        width: "42px",
        borderRadius: "5px",
      }}
    />
  );
};

export default ICOtpInput;
